/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import { CustomSelect } from "../../../../../../../../_helpers/Helpers";

export function SectionDropdown({
  id,
  sections,
  sectionValues,
  setSectionValues
}) {
  const [sectionId, setSectionId] = useState();  

  useEffect(() => {
    const thisValue = sectionValues ? sectionValues.find(value => value.id === id) : undefined;
    const sectionId = thisValue ? thisValue.sectionId : null;
    setSectionId(sectionId);
  }, [id, sectionValues]); 

  return (
    <CustomSelect
      options={sections}
      value={sectionId}
      onBlur={e => e.currentTarget.closest("table").classList.add("overflow-hidden")}
      onFocus={e => e.currentTarget.closest("table").classList.remove("overflow-hidden")}
      onChange={option => {
        const otherValues = sectionValues.filter(value => value.id !== id);
        otherValues.push({ id, sectionId: option.value});
        setSectionValues(otherValues);
      }}
    />
  );
}